/**
 * Unwraps an API response, throwing an error if unsuccessful.
 * @param response The API response to unwrap
 * @param fallbackError Error message to use if response.message is empty
 * @returns The response data
 * @throws Error if response.success is false or data is null/undefined
 */
export function unwrapResponse<T>(response: { success: boolean; data?: T | null; message?: string }, fallbackError: string): T {
  if (!response.success || !response.data) {
    throw new Error(response.message || fallbackError);
  }
  return response.data;
}
